import * as actionType from './ActionType'
import axios from "axios/index";
import {
  asyncForEach,
  hasProperties,
  hasRateByDays,
  isErrorResponse, waitFor
} from "../utils/Util";
import * as Util from "../utils/Util";

export const availabilityRequest = (criteria, message) => {
  return {
    type: actionType.AVAIL_RQ,
    criteria,
    message,
    processing: true
  }
};

export const availabilityReceive = (criteria, availability, message) => {
  return {
    type: actionType.AVAIL_RCV,
    criteria,
    availability,
    message,
    processing: false
  }
};

export const availabilityReceiveError = (criteria, message) => {
  return {
    type: actionType.AVAIL_ERR,
    criteria,
    availability: {
      properties: []
    },
    message,
    processing: false
  }
};

export const staggerAvailabilityFetch = (criteria, api_url, token) => {
  return async (dispatch) => {
    await asyncForEach(criteria.properties, async (property) => {
      await waitFor(300);
      let property_criteria = {
        startDate: criteria.startDate,
        endDate: criteria.endDate,
        properties: [{id: property.id}],
      };

      dispatch(availabilityFetch(property_criteria, api_url, token));
    })
  }
};

export function availabilityFetch(criteria, api_url, token) {
  return function (dispatch) {
    dispatch(availabilityRequest(criteria, 'Requesting...'));
    return axios({
      method: 'post',
      // url: 'https://apps.hti-systems.com/demo2018/eres/admin/direct/ratebyday',
      url: Util.buildRateByDayUrl(api_url),
      // url: 'http://localhost:8086/direct/ratebyday',
      responseType: 'json',
      // auth: {username: 'admin', password: 'hti348'},
      // auth: {username: 'admin', password: 'admin'},
      headers: {'Authorization': 'Bearer '.concat(token)},
      data: criteria
    })
    .then(function (response) {
      if(!isErrorResponse(response)) {
        if(hasRateByDays(response)) {
          dispatch(availabilityReceive(criteria, response.data, 'Done.'));
        }
        else if(hasProperties(response)) {
          console.error('Response has no rates: ' + JSON.stringify(response.data, null, 2));
          // dispatch(availabilityReceiveError('Unexpected error. Please try again later.'))
          dispatch(availabilityReceive(criteria, Util.insertSoldRateByDays(response), 'Done.'));
        }
        else {
          console.error('Response has no properties: ' + JSON.stringify(response.data, null, 2));
          dispatch(availabilityReceiveError(criteria,'Unexpected error. Please try again later.'))
        }
      }
      else {
        console.error('Error response received: ' + JSON.stringify(response.data, null, 2));
        dispatch(availabilityReceiveError(criteria,'Unexpected error. Please try again later.'));
      }
    })
    .catch(function (error) {
      // alert(error);
      console.error('Error occurred: ' + error);
      dispatch(availabilityReceiveError(criteria,'Unexpected error. Please try again later.'));
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error', error.message);
      }
      console.error(error.config);
    });
  }
}

export const showState = (showState) => {
  return {
    type: actionType.AVAIL_SHOW_STATE,
    showState : !showState
  }
};

export const availabilityCustomerKeyChange = (customer_key) => {
  return {
    type: actionType.AVAIL_CUSTOMER_KEY_CHANGE,
    customer_key
  }
};

export const availabilityCustomerRQ = () => {
  return {
    type: actionType.AVAIL_CUSTOMER_RQ,
    processing: true
  }
};

export const availabilityCustomerChange = (customer, token) => {
  return {
    type: actionType.AVAIL_CUSTOMER_CHANGE,
    customer,
    token,
    processing: false
  }
};

export const availabilityCriteriaChange = (criteria) => {
  return {
    type: actionType.AVAIL_CRITERIA_CHANGE,
    criteria
  }
};

export const availabilityRoomChange = (index, room) => {
  return{
    type: actionType.AVAIL_ROOM_CHANGE,
    index,
    room
  }
};

export const availabilityNoOfRoomsChange = (noOfRooms) => {
  return {
   type: actionType.AVAIL_NO_ROOMS_CHANGE,
   noOfRooms
  }
};

export const availabilityNoOfChildrenChange = (index, noOfChildren) => {
  return {
    type: actionType.AVAIL_NO_CHILD_CHANGE,
    index,
    noOfChildren
  }
};

export const availabilityChildAgeChange = (roomIndex, index, age) => {
  return {
    type: actionType.AVAIL_CHILD_AGE_CHANGE,
    roomIndex,
    index,
    age
  }
};

export const availabilityChangeRange = (criteria, days) => {
  return {
    type: actionType.AVAIL_RANGE_CHANGE,
    criteria,
    days
  }
};

export const availabilityChangeRangeAndFetch = (criteria, days) => {
  return (dispatch, getState) => {
    dispatch(availabilityChangeRange(criteria, days));
    // dispatch(availabilityFetch(getState().availabilityReducer.criteria,
    dispatch(staggerAvailabilityFetch(getState().availabilityReducer.criteria,
        getState().availabilityReducer.customer.api_url,
        getState().availabilityReducer.token));
  }
};

export const toggleShowRate = (showRate) => {
  return {
    type: actionType.AVAIL_SHOW_RATE,
    showRate: showRate
  }
};

export const availabilityDisplayNoOfNightsChange = (noOfNights) => {
  return {
    type: actionType.AVAIL_DISPLAY_NO_OF_NIGHTS_CHANGE,
    displayNoOfNights: noOfNights
  }
};

export const muiThemeChange = (muiTheme) => {
  return {
    type: actionType.AVAIL_MUITHEME_CHANGE,
    muiTheme
  }
};


// WEBPACK FOOTER //
// ./src/actions/AvailabilityActions.js